import * as tslib_1 from "tslib";
import React from 'react';
import Fade from 'sinoui-components/transitions/Fade';
var AppearTransition = /** @class */ (function (_super) {
    tslib_1.__extends(AppearTransition, _super);
    function AppearTransition(props) {
        var _this = _super.call(this, props) || this;
        _this.onExited = function () {
            _this.setState({
                exited: true,
            });
        };
        _this.state = {
            exited: !props.open,
        };
        return _this;
    }
    AppearTransition.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.open && prevState.exited) {
            return {
                exited: false,
            };
        }
    };
    AppearTransition.prototype.render = function () {
        var Transtion = this.props.transition;
        return this.state.exited ? null : (React.createElement(Transtion, { in: this.props.open, appear: true, onExited: this.onExited, onEnter: this.props.onEnter, timeout: this.props.timeout }, this.props.children(this.state.exited)));
    };
    AppearTransition.defaultProps = {
        transition: Fade,
    };
    return AppearTransition;
}(React.Component));
export default AppearTransition;
//# sourceMappingURL=AppearTransition.js.map